// 根据设备类型执行不同操作
if (deviceType === 'iOS') {
    // iOS 特定代码
    $('.mac_btn_box,.mac_btn,.mac_inline,.win_inline,.win_btn_box,.win_btn,.win_btn_box,.win_btn,.mac_inline,.win_inline,.mac_btn_box,.mac_btn').css({"display": "none"});
    $('.ios_device').css({"display": "inline"});
    $('.android_device').css({"display": "none"});
    $('.ios_btn').css({"display": "block"});
    $('.android_btn').css({"display": "none"});
} else if (deviceType === 'Android') {
    // Android 特定代码
    $('.mac_btn_box,.mac_btn,.mac_inline,.win_inline,.win_btn_box,.win_btn,.win_btn_box,.win_btn,.mac_inline,.win_inline,.mac_btn_box,.mac_btn').css({"display": "none"});
    $('.ios_device').css({"display": "none"});
    $('.android_device').css({"display": "inline"});
    $('.ios_btn').css({"display": "none"});
    $('.android_btn').css({"display": "block"});
};